<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// App.vue?7ebe4c51